import { atom } from 'recoil';
import { STANDARD_ALLOCATION_TYPE } from '_constants/allocationTypes';

const distributionTypeAtom = atom({
    key: 'distributionType',
    default: localStorage.getItem('distributionType') || STANDARD_ALLOCATION_TYPE,
});

export default distributionTypeAtom;
